import { LiveConnectPlugin } from "../../LiveConnectPlugin/LiveConnectPlugin";
import type {
  GetAsyncPrebidUserIds,
  PrebidIdPartnerConfig,
} from "./IdPartners";
import { hexToBase64 } from "../../../helpers/base64";
import type { PrebidPlugin } from "../PrebidPlugin";

const subscriptionId = "VCaqxS6v2X";
const serverPublicKey =
  "UID2-X-P-MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEOE+DsIa2aJWHIYpG+JrLpe0uxwrGe9aC4NaP7lQMN9+9/pk/7vydOrzQvxeDSlThIiMwGRMpyjAa593RYoGtFA==";

/**
 * @see https://docs.prebid.org/dev-docs/modules/userid-submodules/unified2.html
 */
export const UID2Partner: GetAsyncPrebidUserIds = async (
  config: PrebidIdPartnerConfig,
  plugin: PrebidPlugin,
) => {
  if (!config.icPrebidUID2) {
    return undefined;
  }

  try {
    const liveConnectPlugin = plugin.usePlugin(LiveConnectPlugin);

    if (!liveConnectPlugin) {
      return;
    }

    const hem = await liveConnectPlugin.waitForHem();

    if (hem) {
      return {
        name: "uid2",
        params: {
          serverPublicKey,
          subscriptionId,
          emailHash: hexToBase64(hem),
        },
      };
    }
  } catch {
    return undefined;
  }
  return undefined;
};
